'use client';

import React from 'react';
import styled from '@emotion/styled';
import { breakpoints } from "@argo/principles";
import { keyframes } from '@emotion/react';
const LoadingState = styled.button`
  padding: ${props => props?.slimLittleGuy ? '20px 8px' : '20px 12px'};
  border: 0;
  background: transparent;
  text-align: center;
  align-self: center;
  cursor: not-allowed;
  margin-right: 8px;
  @media (min-width: ${breakpoints.max}px) {
    margin-right: 0;
    padding: 20px 24px;
  }
`;
const shineEffect = keyframes`
  0% {
    background-position: right;
  }
`;
const LoaderContainer = styled.div`
  height: 24px;
  width: 53px;
  width: ${props => props?.slimLittleGuy ? '24px' : '53px'};

  @media (min-width: ${breakpoints.max}px) {
    width: ${props => props?.slimLittleGuy ? '53px' : '81px'};
  }
`;
const LoadingIcon = styled.div`
  background-color: rgb(23,46,117);
  width: ${props => props?.slimLittleGuy ? '24px' : '53px'};
  height: 24px;
  background-image: linear-gradient(103deg, transparent 33%, rgba(255, 255, 255, 0.2) 50%, transparent 66%);
  background-size: 300% 100%;
  animation: ${shineEffect} 1.5s infinite;

  @media (min-width: ${breakpoints.max}px) {
    width: ${props => props?.slimLittleGuy ? '53px' : '81px'};
  }
`;
const LittleGuyLoader = ({
  slimLittleGuy = false
}) => {
  return React.createElement(LoadingState, {
    disabled: true,
    id: "loadingState",
    slimLittleGuy: slimLittleGuy
  }, React.createElement(LoaderContainer, {
    "aria-hidden": "true",
    id: "loaderContainer",
    slimLittleGuy: slimLittleGuy
  }, React.createElement(LoadingIcon, {
    id: "loadingIcon",
    slimLittleGuy: slimLittleGuy
  })));
};
export default LittleGuyLoader;